import React from 'react';
import SEO from './SEO';
import './LegalPages.css';

function TermsOfService() {
  return (
    <main id="main-content" className="legal-page">
      <SEO
        title="Terms of Service | UBOTIKA"
        description="UBOTIKA's terms of service: how our AI agent and AI receptionist services may be used, what we provide, billing terms, and the limits of our liability."
        path="/terms"
      />
      <div className="legal-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last Updated: November 21, 2025</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using the Ubotika website (ubotika.com), you accept and agree to be
            bound by the terms and provisions of this agreement. If you do not agree to these terms,
            please do not use our website or services.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            Ubotika provides AI-powered automation solutions, including but not limited to:
          </p>
          <ul>
            <li>AI agents and intelligent automation systems</li>
            <li>Workflow automation solutions</li>
            <li>CRM integration services</li>
            <li>Smart communication systems</li>
            <li>Analytics and insights</li>
            <li>AI phone systems</li>
          </ul>
        </section>

        <section>
          <h2>3. Use License</h2>
          <p>
            Permission is granted to temporarily access the materials (information or software) on
            Ubotika's website for personal, non-commercial transitory viewing only. This is the grant
            of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose</li>
            <li>Attempt to decompile or reverse engineer any software on the website</li>
            <li>Remove any copyright or proprietary notations from the materials</li>
            <li>Transfer the materials to another person or "mirror" the materials on another server</li>
          </ul>
        </section>

        <section>
          <h2>4. Disclaimer</h2>
          <p>
            The materials on Ubotika's website are provided on an 'as is' basis. Ubotika makes no
            warranties, expressed or implied, and hereby disclaims and negates all other warranties
            including, without limitation, implied warranties or conditions of merchantability,
            fitness for a particular purpose, or non-infringement of intellectual property or other
            violation of rights.
          </p>
        </section>

        <section>
          <h2>5. Limitations</h2>
          <p>
            In no event shall Ubotika or its suppliers be liable for any damages (including, without
            limitation, damages for loss of data or profit, or due to business interruption) arising
            out of the use or inability to use the materials on Ubotika's website, even if Ubotika
            or an authorized representative has been notified orally or in writing of the possibility
            of such damage.
          </p>
        </section>

        <section>
          <h2>6. Accuracy of Materials</h2>
          <p>
            The materials appearing on Ubotika's website could include technical, typographical, or
            photographic errors. Ubotika does not warrant that any of the materials on its website
            are accurate, complete, or current. Ubotika may make changes to the materials contained
            on its website at any time without notice.
          </p>
        </section>

        <section>
          <h2>7. Links</h2>
          <p>
            Ubotika has not reviewed all of the sites linked to its website and is not responsible
            for the contents of any such linked site. The inclusion of any link does not imply
            endorsement by Ubotika of the site. Use of any such linked website is at the user's own
            risk.
          </p>
        </section>

        <section>
          <h2>8. Modifications</h2>
          <p>
            Ubotika may revise these terms of service for its website at any time without notice.
            By using this website you are agreeing to be bound by the then current version of these
            terms of service.
          </p>
        </section>

        <section>
          <h2>9. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws
            of California, United States, and you irrevocably submit to the exclusive jurisdiction
            of the courts in that location.
          </p>
        </section>

        <section>
          <h2>10. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us through our
            contact form or email us at: <a href="mailto:legal@ubotika.com">legal@ubotika.com</a>
          </p>
        </section>

        <div className="legal-back-link">
          <a href="/">← Back to Home</a>
        </div>
      </div>
    </main>
  );
}

export default TermsOfService;
